"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderColumn = exports.reformatStates = exports.reformatDictionary = exports.filter = exports.dateRangeFilter = exports.datePeriodFilter = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var filter = function filter(key) {
  return function (value, record) {
    return record[key] === value;
  };
};
exports.filter = filter;
var dateRangeFilter = function dateRangeFilter(key) {
  return function (value, record) {
    var date = (0, _momentTimezone.default)(record[key]);
    if (!(value !== null && value !== void 0 && value.length)) {
      return true;
    }
    return date.isSameOrAfter(value[0].startOf('day')) && date.isSameOrBefore(value[1].endOf('day'));
  };
};
exports.dateRangeFilter = dateRangeFilter;
var datePeriodFilter = function datePeriodFilter(keyStart, keyEnd) {
  return function (value, record) {
    if (!value.length) {
      return true;
    }
    var start = (0, _momentTimezone.default)(record[keyStart]).startOf('day');
    var end = (0, _momentTimezone.default)(record[keyEnd]).endOf('day');
    return (end.isSameOrAfter(value[0]) || record[keyEnd] === null) && start.isSameOrBefore(value[1]);
  };
};

// TODO@Midori: rename this util to getFiltersForValues once code paths are sorted out
exports.datePeriodFilter = datePeriodFilter;
var reformatDictionary = function reformatDictionary(dictionary) {
  var render = {};
  dictionary === null || dictionary === void 0 ? void 0 : dictionary.forEach(function (item) {
    render[item.id] = item.label;
  });
  return {
    filters: dictionary === null || dictionary === void 0 ? void 0 : dictionary.map(function (item) {
      return {
        value: item.id,
        text: item.label
      };
    }),
    render: render
  };
};
exports.reformatDictionary = reformatDictionary;
var reformatStates = function reformatStates(states) {
  states = states.map(function (item) {
    return {
      id: item.code,
      label: item.name
    };
  });
  return reformatDictionary(states);
};
exports.reformatStates = reformatStates;
var renderColumn = function renderColumn(preparedData, key) {
  return function (value, record) {
    return preparedData.render[record[key]];
  };
};
exports.renderColumn = renderColumn;